import React from 'react';
import { browserHistory } from 'react-router';
import { Button, Space } from 'antd';
import { formatISO } from 'date-fns';
import { DeleteOutlined, RedoOutlined } from '@ant-design/icons';
import { Table } from '@yuhuinc/ui-library';

import { getTranslatedString } from 'helpers/i18n';

export default function ArchivedTemplates({
  templates,
  loading,
  restoreApplicationTemplate,
  deleteApplicationTemplate,
}) {
  const columns = [
    {
      title: getTranslatedString('landlordPortal.applicationTemplate.table.name'),
      dataIndex: 'name',
      searchable: true,
      sorter: (a, b) => a.name.length - b.name.length,
      render: (text, record) => (
        <Button
          type="text"
          onClick={() => browserHistory.push(`/companies/application_templates/${record.id}/edit`)}
        >
          {text}
        </Button>
      ),
    },
    {
      title: getTranslatedString('common.archived'),
      dataIndex: 'updated_at',
      sorter: (a, b) => a.updatedAt - b.updatedAt,
      render: (updatedAt) => formatISO(new Date(updatedAt), { representation: 'date' }),
    },
    {
      title: getTranslatedString('landlordPortal.applicationTemplate.table.languages'),
      dataIndex: 'selected_languages',
      render: (text) =>
        text.map((language) => getTranslatedString(`languages.${language}`)).join(', '),
    },
    {
      title: getTranslatedString('landlordPortal.applicationTemplate.table.actions'),
      key: 'action',
      render: (index) => (
        <Space>
          <Button
            type="link"
            icon={<RedoOutlined />}
            onClick={() => restoreApplicationTemplate(index)}
          />
          <Button
            type="link"
            icon={<DeleteOutlined />}
            onClick={() => deleteApplicationTemplate(index)}
          />
        </Space>
      ),
    },
  ];

  return (
    <Table
      dataSource={templates}
      columns={columns}
      loading={loading}
      pagination={{
        total: templates.length,
        hideOnSinglePage: true,
        size: 'small',
      }}
      resetButtonOnClick={() => {}}
      title={getTranslatedString('landlordPortal.applicationTemplate.table.archivedTemplates')}
      scroll={{ x: false }}
    />
  );
}
